"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgAlignCenter = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5 7c-.666 0-1-.333-1-1s.333-1 1-1h13.995c.669 0 1.003.333 1.005 1 .002.667-.332 1-1 1H5zm4 4c-.666 0-.999-.333-1-1-.001-.667.331-1 .997-1H15c.667 0 1 .332 1 1 0 .668-.333 1-1 1H9zm-4 4c-.666 0-1-.332-1-1 0-.668.332-1 .998-1H19c.667 0 1 .333 1 1s-.333 1-1 1H5zm4 4c-.668 0-1.001-.333-1-1 .001-.667.336-1 1.003-1H15c.667.006 1 .341 1 1.005 0 .663-.333.995-1 .995H9z' }))); };
exports.default = SvgAlignCenter;
//# sourceMappingURL=AlignCenter.js.map